





































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import {
  HsabAccountNametag,
} from "@/shared/types";
import { hsabAccountIcon } from "@/shared/awesomeIconMapper";
import { formatCurrency } from "@/shared/currency.js";
import { formatMMMDateString } from "@/shared/dateString";
import NotionalAccountCardBody from "@/employee/components/landing-pages/accountSummaryDashboard/NotionalAccountCardBody.vue";
import HsaAccountCardBody from "@/employee/components/landing-pages/accountSummaryDashboard/HsaAccountCardBody.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import moment from "moment";
import AccountBalanceStackedChart from "./AccountBalanceStackedChart.vue";
import NotionalBalanceLineChart from "@/shared/components/charts/NotionalLineChart.vue";
import BalanceAmount from "@/employee/components/landing-pages/accountSummaryDashboard/BalanceAmount.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useHsabDailyBalanceStore } from "@/employee/store/hsabDailyBalance";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";

@Component({
  components: {
    NotionalBalanceLineChart,
    AccountBalanceStackedChart,
    SsoDeepLink,
    NotionalAccountCardBody,
    HsaAccountCardBody,
    BalanceAmount
  }
})
export default class HsaAccountCard extends Vue {
  featureFlagStore = useFeatureFlagStore();
  hsabAccountsStore = useHsabAccountsStore();
  dailyBalanceStore = useHsaDailyBalanceStore();
  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  hsabBalanceStore = useHsabDailyBalanceStore();
  investmentThresholdStore = useInvestmentThresholdStore();

  formatMMMDateString = formatMMMDateString;
  formatCurrency = formatCurrency;

  @Prop({ required: true })
  account: HsabAccountNametag;

  @Prop()
  minHeight: string;

  @Prop({ default: false })
  showNavigationButton: boolean;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ default: false })
  hideChart: boolean;

  @Watch("username")
  @Watch("partnerId")
  reloadDailyBalancesChart () {
    this.loadDailyBalances();
  }

  get showChart () {
    return !this.hideChart &&
        this.hsabBalanceStore.balancesForCurrentDates !== null;
  }

  get cardTitle () {
    let title = this.account.accountName;
    if (!this.account.isActive) {
      title += " (Inactive)";
    }
    return title;
  }

  get mostRecentCashBalanceDate (): string {
    if (this.dailyBalanceStore.instantBalance.amount) {
      return moment().format("MMM D, YYYY");
    }
    if (this.dailyBalanceStore.balanceOnFileDate) {
      return moment(this.dailyBalanceStore.balanceOnFileDate).format("MMM D, YYYY");
    }
    return "";
  }

  get displayIconForAccount () {
    return hsabAccountIcon(this.account);
  }

  get cashAccountBalance (): number {
    return this.dailyBalanceStore.instantBalance.amount || this.dailyBalanceStore.balanceOnFileAmount;
  }

  mounted () {
    this.dailyBalanceStore.loadBalanceOnFile({ username: this.username, partnerId: this.partnerId });
    this.dailyBalanceStore.loadInstantBalance({ username: this.username, partnerId: this.partnerId });
    this.investmentThresholdStore.loadInvestmentThresholds({ username: this.username, partnerId: this.partnerId });
    this.hsabBalanceStore.setCurrentEndDateKey(moment().add(1, "day").format("YYYYMMDD"));
    this.loadDailyBalances(true);
  }

  loadDailyBalances (force = false) {
    const startDate = moment().subtract(6, "months").format("YYYY-MM-DD");
    const endDate = moment().add(1, "day").format("YYYY-MM-DD");

    // This endpoint IS NOT by account number. HSAB users cannot have more than one HSA.
    this.hsabBalanceStore.loadHsabHsaDailyBalances({
      startDate,
      endDate
    }, false);
    this.investmentDailyBalanceStore.loadDailyInvestmentBalances({
      startDate,
      endDate,
      username: this.username,
      partnerId: this.partnerId
    });
  }

  navigateToAccount () {
    this.hsabAccountsStore.navigateToAccountPage(this.account);
  }
}
